export default "__VITE_ASSET__781e1c8f__"